export enum BankView {
  MY_ACCOUNTS = 1,
  ACCOUNT = 2,
  TRANSACTION = 3,
  ADD_ACCOUNT = 4,
  LIST_ACCOUNTS = 5,
  FIO = 6,
  FIO_TRANSACTION = 7,
  STATISTICS = 8,
  EDIT_TRANSACTION = 9,
  ACCOUNT_PAYMENT = 10,
  ACCOUNT_CANCEL = 12,
}
